import ShareToSocialMediaComponent from './ShareToSocialMediaComponent';

const ShareToSocialMedia = ({ slice, context }) => {
  const { data } = context || {};
  return <ShareToSocialMediaComponent pageData={data} />;
};

export default ShareToSocialMedia;
